export const MODAL_BUTTON_VARIANTS = {
  primary  : 'primary',
  secondary: 'secondary',
  warning  : 'warning',
  ko       : 'ko',
  ok       : 'ok',
};
